<script setup lang="ts">
import { computed } from "vue";
import type { CountdownStyleProps } from "./shared";

const props = defineProps<CountdownStyleProps>();

// IMPORTANT: this template intentionally mirrors the original CountdownBlock
// markup so existing snapshot/DOM tests (`.tpl:gap-2`, `.tpl:text-center > div`)
// continue to pass when `style` is unset or `"minimal"`.

const containerStyle = computed(() => ({
  backgroundColor: props.block.backgroundColor,
  fontFamily: props.block.fontFamily || "inherit",
}));

const digitStyle = computed(() => ({
  fontSize: `${props.block.digitFontSize}px`,
  fontWeight: "bold" as const,
  color: props.block.digitColor,
  lineHeight: "1.2",
}));

const labelStyle = computed(() => ({
  fontSize: `${props.block.labelFontSize}px`,
  color: props.block.labelColor,
  marginTop: "4px",
}));

const separatorStyle = computed(() => ({
  fontSize: `${props.block.digitFontSize}px`,
  color: props.block.digitColor,
  fontFamily: props.block.fontFamily || "inherit",
}));
</script>

<template>
  <div
    :style="containerStyle"
    class="tpl:flex tpl:items-center tpl:justify-center tpl:gap-2 tpl:py-4"
  >
    <template v-for="(segment, index) in segments" :key="segment.label">
      <span v-if="index > 0" :style="separatorStyle" class="tpl:self-start">
        {{ separator }}
      </span>
      <div class="tpl:text-center">
        <div :style="digitStyle">{{ segment.value }}</div>
        <div :style="labelStyle">{{ segment.label }}</div>
      </div>
    </template>
  </div>
</template>
